<gd-dialog-container (close)="close()" [class]="size">
  <div class="header">
    {{ context.title }}
  </div>

  <div class="content flex">
    <div class="preview" *ngIf="previewUrl">
      <img class="image" [src]="previewUrl" alt="Mockup Preview" />
    </div>

    <div class="form-container">
      <p>{{ context.description }}</p>

      <div class="ui form">
        <div class="field">
          <input type="text" name="templateName" [id]="'templateName'" [(ngModel)]="templateName" />
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <button class="ui secondary button" (click)="close()" data-lokalise data-key="txt_cancel"></button>
    <button class="ui primary button" [class.disabled]="approveDisabled" (click)="approve()">
      {{ context.actionButtonText }}
    </button>
  </div>
</gd-dialog-container>
